<template>
    <information-modal
        title="Delete"
        :show-footer="true"
        :width="450"
        className="confirm"
        v-model="isShowConfirmDelete">
        Are You Sure?
        <template v-slot:footer>
            <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal">
                No
            </button>
            <button
                type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
                @click.prevent="deleteItem">
                Yes
            </button>
        </template>
    </information-modal>
    <form-modal
        :title="editDialogTitle"
        v-model="isShowEditEditor"
        @submit="createUser">
        <fieldset>
            <div class="mb-3 row">
                <label
                    for="auditorName"
                    class="col-sm-3 col-form-label">
                    User name:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="username"
                        type="text"
                        v-model="user.userName"
                        :error="errors.userName" />
                </div>
            </div>
            <div
                class="mb-3 row"
                v-if="userFieldStates['password']?.visible">
                <label
                    for="password"
                    class="col-sm-3 col-form-label">
                    Password:
                </label>
                <div class="col-sm-9">
                    <b-password
                        name="password"
                        type="text"
                        v-model="user.password"
                        :show-password="selectedUserId < 0"
                        :error="errors.password" />
                </div>
            </div>
            <div
                class="mb-3 row"
                v-if="userFieldStates['password']?.visible">
                <label
                    for="confirmPassword"
                    class="col-sm-3 col-form-label">
                    Confirm password:
                </label>
                <div class="col-sm-9">
                    <b-password
                        name="confirmPassword"
                        :show-password="selectedUserId < 0"
                        type="text"
                        v-model="user.confirmPassword"
                        :error="errors.confirmPassword" />
                </div>
            </div>

            <div
                class="mb-3 row"
                v-if="userFieldStates['firstName']?.visible">
                <label
                    for="firstName"
                    class="col-sm-3 col-form-label">
                    First name:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="firstName"
                        type="text"
                        v-model="user.firstName"
                        :error="errors.firstName" />
                </div>
            </div>

            <div
                class="mb-3 row"
                v-if="userFieldStates['lastName']?.visible">
                <label
                    for="lastName"
                    class="col-sm-3 col-form-label">
                    Last name:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="lastName"
                        type="text"
                        v-model="user.lastName"
                        :error="errors.lastName" />
                </div>
            </div>

            <div
                class="mb-3 row"
                v-if="userFieldStates['organization']?.visible">
                <label
                    for="organization"
                    class="col-sm-3 col-form-label">
                    Organization:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="organization"
                        type="text"
                        v-model="user.organization"
                        :error="errors.organization" />
                </div>
            </div>

            <div
                class="mb-3 row"
                v-if="userFieldStates['email']?.visible">
                <label
                    for="email"
                    class="col-sm-3 col-form-label">
                    Email:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="email"
                        type="text"
                        v-model="user.email"
                        :error="errors.email" />
                </div>
            </div>

            <div
                class="mb-3 row"
                v-if="userFieldStates['custom1']?.visible">
                <label
                    for="custom1"
                    class="col-sm-3 col-form-label">
                    Custom1:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="custom1"
                        type="text"
                        :disabled="!userFieldStates['custom1'].editable"
                        v-model="user.custom1"
                        :error="errors.custom1" />
                </div>
            </div>
            <div
                class="mb-3 row"
                v-if="userFieldStates['custom2']?.visible">
                <label
                    for="custom2"
                    class="col-sm-3 col-form-label">
                    Custom2:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="custom2"
                        type="text"
                        :disabled="!userFieldStates['custom2'].editable"
                        v-model="user.custom2"
                        :error="errors.custom2" />
                </div>
            </div>
            <div
                class="mb-3 row"
                v-if="userFieldStates['custom3']?.visible">
                <label
                    for="custom3"
                    class="col-sm-3 col-form-label">
                    Custom3:
                </label>
                <div class="col-sm-9">
                    <b-input
                        name="custom3"
                        type="text"
                        :disabled="!userFieldStates['custom3'].editable"
                        v-model="user.custom3"
                        :error="errors.custom3" />
                </div>
            </div>

            <div class="mb-4 row">
                <label
                    for="role"
                    class="col-sm-3 col-form-label">
                    Role:
                </label>
                <div class="col-sm-9">
                    <b-select
                        v-model="user.roleId"
                        :items="roles"></b-select>
                </div>
            </div>

            <div
                class="mb-3 row"
                v-if="userFieldStates['apiKey']?.visible">
                <label
                    for="apiKey"
                    class="col-sm-3 col-form-label">
                    Api Key:
                </label>
                <div class="col">
                    <div class="input-group">
                        <b-input
                            name="apiKey"
                            :disabled="true"
                            type="text"
                            v-model="user.apiKey"
                            :error="errors.apiKey" />
                        <button
                            v-if="user.apiKey"
                            class="input-group-text"
                            type="button"
                            id="button-addon2"
                            @click.prevent="copyApiKey(user.apiKey)"
                            v-tooltip="`Copy Api Key`">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-copy"
                                viewBox="0 0 16 16">
                                <path
                                    fill-rule="evenodd"
                                    d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="col align-content-center text-end">
                    <b-button
                        @click.prevent="addApiKey()"
                        size="sm"
                        class="me-2">
                        Generate Api Key
                    </b-button>
                    <b-button
                        @click.prevent="removeApiKey()"
                        variant="danger"
                        size="sm">
                        Remove Api Key
                    </b-button>
                </div>
            </div>

            <div
                class="mb-4 row"
                v-if="userFieldStates['ori']?.visible">
                <label
                    for="role"
                    class="col-sm-3 col-form-label">
                    Linked Agencies:
                </label>
                <div class="col-sm-9 mt-2">
                    <div v-if="user.oris?.length > 0">
                        <div class="row agency-access mb-3">
                            <div class="col-7">Agency</div>
                            <div class="col-3">Repository Access</div>
                            <div class="col-1"></div>
                        </div>
                        <div
                            class="row mb-2"
                            v-for="(item, index) in user.oris">
                            <div class="col-7">
                                <b-agency
                                    v-model="item.ori"
                                    :excluded-oris="userOris"></b-agency>
                            </div>
                            <div class="col-3 text-center align-content-center">
                                <div class="form-check-inline">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="item.allowUpload"
                                        value=""
                                        id="flexCheckDefault" />
                                </div>
                            </div>
                            <div class="col-1 align-content-center">
                                <b-button
                                    @click.prevent="deleteOri(index)"
                                    v-if="canDelete"
                                    variant="danger"
                                    size="sm">
                                    Delete
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <b-alert variant="info">None</b-alert>
                    </div>
                    <div class="mt-3">
                        <button
                            @click.prevent="addOri"
                            v-if="canAdd"
                            class="btn btn-sm btn-primary">
                            Add an agency
                        </button>
                    </div>
                </div>
            </div>

            <div class="mb-4 row">
                <div class="col">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            v-model="user.isEnabled"
                            id="enabled" />
                        <label
                            class="form-check-label"
                            for="enabled">
                            Enabled
                        </label>
                    </div>
                </div>
            </div>
        </fieldset>
    </form-modal>

    <form-modal
        title="Settings"
        v-model="isShowSettingsEditor"
        :width="450"
        @submit="updateSettings">
        <table
            class="table table-light table-striped"
            style="table-layout: fixed">
            <thead>
                <tr class="text-center">
                    <th class="text-start">Setting</th>
                    <th>Visible</th>
                    <th>Required</th>
                    <th>Editable</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in settingFields"
                    class="text-center">
                    <td class="text-start">{{ item.label }}</td>
                    <td>
                        <input
                            class="form-check-input"
                            v-model="item.visible"
                            type="checkbox"
                            :disabled="!item.visibleEnabled"
                            value="" />
                    </td>
                    <td>
                        <input
                            class="form-check-input"
                            v-model="item.required"
                            type="checkbox"
                            :disabled="!item.requiredEnabled"
                            value="" />
                    </td>
                    <td>
                        <input
                            class="form-check-input"
                            v-model="item.editable"
                            type="checkbox"
                            :disabled="!item.editableEnabled"
                            value="" />
                    </td>
                </tr>
            </tbody>
        </table>
    </form-modal>
    <b-grid
        caption="Users"
        :tableOptions="userStore.tableOptions"
        :filterableFields="userStore.filterableFields"
        :filterOptions="userStore.filterOptions"
        @optionChange="getData"
        :items="userStore.items"
        :columns="columns"
        :loading="userStore.loading">
        <template #beforeFilter>
            <b-button
                @click.prevent="showEditEditor(-1)"
                v-if="canAdd"
                >Add new user</b-button
            >
            <b-button
                @click.prevent="showSettingsEditor"
                v-if="canAdd"
                >Settings</b-button
            >
        </template>
        <template #cell.apiKey="{item}">
            <div
                class="input-group input-group-sm"
                v-if="item.apiKey">
                <b-input
                    :disabled="true"
                    type="text"
                    v-model="item.apiKey" />
                <button
                    v-if="item.apiKey"
                    class="input-group-text"
                    type="button"
                    @click.prevent="copyApiKey(item.apiKey)"
                    v-tooltip="`Copy Api Key`">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-copy"
                        viewBox="0 0 16 16">
                        <path
                            fill-rule="evenodd"
                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                    </svg>
                </button>
            </div>
        </template>
        <template #cell.ori="{item}">
            <div v-for="it in item.oris">
                {{ it.ori }}
                <i
                    class="bi bi-check-lg text-success"
                    v-if="it.allowUpload"></i>
                <i
                    class="bi bi-x-lg text-danger"
                    v-else></i>
            </div>
        </template>
        <template #cell.isEnabled="{item}">
            <i
                class="bi bi-check-lg text-success"
                v-if="item.isEnabled"></i>
            <i
                class="bi bi-x-lg text-danger"
                v-else></i>
        </template>
        <template #cell.roleName="{item}">
            {{ item.roleName }}
        </template>
        <template #cell.actions="{item}">
            <div class="button-wrapper">
                <b-button
                    @click.prevent="showEditEditor(item.userId)"
                    v-if="canEdit"
                    size="sm">
                    Edit
                </b-button>
                <b-button
                    @click.prevent="deleteItemConfirm(item.userId)"
                    v-if="canDelete"
                    size="sm"
                    variant="danger">
                    Delete
                </b-button>
                <span v-else></span>
            </div>
        </template>
    </b-grid>

    <system-alerts></system-alerts>
</template>
<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {BTableColumn} from "./BTable/BTable.types";
import {useUserStore} from "@/stores/userStore";
import {FormModal, InformationModal, SystemAlerts} from "./Misc";
import BGrid from "./BGrid/BGrid.vue";
import type {UserInformation, UserOri, UserField} from "@/types";
import {useFormValidation} from "@/validation";
import {object, string} from "yup";
import * as Yup from "yup";
import {useRoleStore} from "@/stores/roleStore";
import {useAuthStore} from "@/stores/authStore";
import {BSelect, BInput, BPassword, BAgency} from "./Fields";
import {BButton} from "./BButton";
import {BAlert} from "./BAlert";
import {clone} from "@/utils";

const isShowEditEditor = ref(false);
const isShowSettingsEditor = ref(false);
const userStore = useUserStore();
const roleStore = useRoleStore();
const authStore = useAuthStore();

const sorter = [
    "userName",
    "password",
    "firstName",
    "lastName",
    "organization",
    "email",
    "ori",
    "custom1",
    "custom2",
    "custom3",
    "roleName",
    "apiKey",
    "isEnabled",
    "actions",
];

const columns = ref<BTableColumn[]>();
const baseColumns = ref<BTableColumn[]>([
    {
        key: "roleName",
        text: "Role",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.roleName,
    },

    {
        key: "isEnabled",
        text: "Enabled",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.isEnabled,
    },

    {
        key: "actions",
        text: "",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap text-end"],
        value: (item) => item["link"],
    },
]);

interface UserFieldState {
    visible: boolean;
    required: boolean;
    editable: boolean;
}

const userFieldStates: {[id: string]: UserFieldState} = {};

const canAdd = computed(() => {
    return true;
});
const canDelete = computed(() => {
    return true;
});
const canEdit = computed(() => {
    return true;
});

const userOris = computed(() => {
    return user.value.oris.map((x) => x.ori);
});

const editDialogTitle = computed(() => {
    return selectedUserId.value == -1 ? "Add new user" : `Edit user - ${user.value.userName}`;
});

const user = ref<UserInformation>({} as UserInformation);
const selectedUserId = ref(-1);
const isShowConfirmDelete = ref(false);
const deleteItemConfirm = async (id: number) => {
    isShowConfirmDelete.value = true;
    selectedUserId.value = id;
};

const schema = object<UserInformation>({
    userName: string()
        .required()
        .label("Username")
        .test("username-backend-validation", "Username already exists.", async (username) => {
            return userStore.validateUsername(selectedUserId.value, username);
        }),
    password: string()
        .label("Password")
        .when([], {
            is: () => userFieldStates["password"].required === true,
            then: (schema) => schema.required(),
        })
        .test("password-backend-validation", async (password, {createError}) => {
            if (password && user.value.userName) {
                var errors = await authStore.validateNewPassword(user.value.userName, password!);
                if (errors?.length) {
                    return createError({
                        message: errors[0],
                    });
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }),
    confirmPassword: string()
        .label("Confirm Password")
        .oneOf([Yup.ref("password")], "Passwords must match")
        .when([], {
            is: () => userFieldStates["password"].required === true,
            then: (schema) => schema.required(),
        }),
    firstName: string()
        .nullable()
        .label("First Name")
        .when([], {
            is: () => userFieldStates["firstName"].required === true,
            then: (schema) => schema.required(),
        }),
    lastName: string()
        .nullable()
        .label("Last Name")
        .when([], {
            is: () => userFieldStates["lastName"].required === true,
            then: (schema) => schema.required(),
        }),
    organization: string()
        .label("Organization")
        .when([], {
            is: () => userFieldStates["organization"].required === true,
            then: (schema) => schema.required(),
        }),
    email: string()
        .nullable()
        .email()
        .label("Email")
        .when([], {
            is: () => userFieldStates["email"].required === true,
            then: (schema) => schema.required().email(),
        }),
    custom1: string()
        .nullable()
        .label("Custom1")
        .when([], {
            is: () => userFieldStates["custom1"].required === true,
            then: (schema) => schema.required(),
        }),
    custom2: string()
        .nullable()
        .label("Custom2")
        .when([], {
            is: () => userFieldStates["custom2"].required === true,
            then: (schema) => schema.required(),
        }),
    custom3: string()
        .nullable()
        .label("Custom3")
        .when([], {
            is: () => userFieldStates["custom3"].required === true,
            then: (schema) => schema.required(),
        }),

    roleId: string().required().label("Role"),
});

const createUser = async () => {
    if (await handleSubmit(schema, user.value)) {
        if (selectedUserId.value == -1) {
            await userStore.create(user.value);
        } else {
            await userStore.update(selectedUserId.value, user.value);
        }

        isShowEditEditor.value = false;
        await getData();
    }
};

const roles = computed(() => {
    return roleStore.items?.map((x) => ({value: x.roleId, text: x.roleName}));
});

const deleteItem = async () => {
    await userStore.deleteItem(selectedUserId.value);
    await getData();
};

const showEditEditor = async (userId: number) => {
    selectedUserId.value = userId;
    resetValidation();

    if (userId == -1) {
        user.value = {} as UserInformation;
        user.value.isEnabled = true;
        user.value.oris = [{ori: "", allowUpload: true}];
        let defaultItem = roleStore.items?.find((x) => x.defaultFlag);
        if (defaultItem) {
            user.value.roleId = defaultItem.roleId;
        }
    } else {
        user.value = await userStore.getById(userId);
        user.value.confirmPassword = user.value.password;
    }
    isShowEditEditor.value = true;
};

const settingFields = ref<UserField[]>();

const showSettingsEditor = async () => {
    isShowSettingsEditor.value = true;
    settingFields.value = clone(
        userStore.userFields!.sort(function (a, b) {
            if (sorter.indexOf(a["fieldName"]) > sorter.indexOf(b["fieldName"])) {
                return 1;
            } else {
                return -1;
            }
        })
    );
};

const updateSettings = async () => {
    await userStore.updateSettings(settingFields.value!);
    await loadUserFields();
    isShowSettingsEditor.value = false;
};

const getData = async () => {
    await userStore.list();
};

const addApiKey = async () => {
    user.value.apiKey = await userStore.generateApiKey(selectedUserId.value);
};

const removeApiKey = async () => {
    user.value.apiKey = "";
};

const copyApiKey = async (key: string) => {
    navigator.clipboard.writeText(key);
};

const loadUserFields = async () => {
    await userStore.listUserFields();

    columns.value = clone(baseColumns.value);
    userStore!.userFields!.forEach(function (value) {
        userFieldStates[value.fieldName] = {
            visible: value.visible,
            editable: value.editable,
            required: value.required,
        };

        if (value.visible) {
            columns.value!.push({
                key: value.fieldName,
                text: value.label,
                sortable: true,
                columnClass: ["align-top"],
                class: (item) => ["text-nowrap"],
                value: (item) => item[value.fieldName],
            });
        }
    });

    columns.value = columns.value
        .filter((o) => o.key != "password")
        .sort(function (a, b) {
            if (sorter.indexOf(a["key"]) > sorter.indexOf(b["key"])) {
                return 1;
            } else {
                return -1;
            }
        });
};

const deleteOri = async (index: number) => {
    user.value.oris.splice(index, 1);
};
const addOri = async () => {
    user.value.oris.push({allowUpload: true} as UserOri);
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

onMounted(async () => {
    await loadUserFields();
    await roleStore.list();
    await getData();
});
</script>
<style>
.agency-access {
    font-size: 0.9rem;
}
</style>
